module.exports = __webpack_public_path__ + "static/media/userPlus.bd348765.svg";